(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["biuti-lower"] && !Shopify.designMode) return;
  try {
    (function () {
      if (window.__biutiPackModalWired) return;
      window.__biutiPackModalWired = true;
  
      function imageOf(dialog) { return dialog.querySelector('[data-biuti-pack-image]'); }
      function closeDialog(dialog) {
        if (dialog && dialog.open) dialog.close();
      }
  
      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-biuti-pack-zoom]');
        if (trigger) {
          var section = trigger.closest('.biuti-pack-specs');
          var dialog = section && section.querySelector('[data-biuti-pack-dialog]');
          if (!dialog) return;
          var image = imageOf(dialog);
          image.src = trigger.dataset.zoomSrc;
          image.alt = trigger.dataset.zoomAlt || '';
          dialog.querySelector('[data-biuti-pack-caption]').textContent = trigger.dataset.zoomCaption || '';
          dialog.__returnFocus = trigger;
            dialog.showModal();
          return;
        }
  
        var close = event.target.closest('[data-biuti-pack-close]');
        if (close) {
          closeDialog(close.closest('dialog'));
          return;
        }
  
          if (event.target.matches('[data-biuti-pack-dialog]')) closeDialog(event.target);
      });
  
      function wireDialogs() {
        document.querySelectorAll('[data-biuti-pack-dialog]:not([data-biuti-wired])').forEach(function (dialog) {
          dialog.dataset.biutiWired = 'true';
          dialog.addEventListener('close', function () {
              var image = imageOf(dialog);
              image.removeAttribute('src');
              if (dialog.__returnFocus) dialog.__returnFocus.focus();
          });
        });
      }
  
      wireDialogs();
      new MutationObserver(wireDialogs).observe(document.body, { childList: true, subtree: true });
    })();
  } catch(e) { console.error(e); }
})();

})();
